export const PLAYER_SNAP_SIDEPANEL_WIDTH = 330;
